import { ReactNode } from 'react';
import { Link } from './styles';

export type ExternalLinkType = {
  children: ReactNode;
  href: string;
  target?: '_blank' | '_self';
};

export const ExternalLink = ({ children, href, target = '_blank' }: ExternalLinkType) => {
  return (
    <Link href={href} target={target} rel='noreferrer'>
      {children}
    </Link>
  );
};
